import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { SecurityProfileQuiz, SecurityProfileResponse } from './types';

export const securityProfileService = (client: AxiosInstance) => {
  const getSecurityProfileQuiz = async (
    accountId: string,
  ): Promise<SecurityProfileQuiz> => {
    try {
      const result = await client.get<
        SecurityProfileQuiz,
        AxiosResponse<SecurityProfileQuiz>
      >(`/accounts/${accountId}/security-profile-quiz`, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const submitSecurityProfileResponses = async (
    accountId: string,
    responses: SecurityProfileResponse[],
  ): Promise<void> => {
    try {
      await client.post<void, AxiosResponse<void>>(
        `/accounts/${accountId}/security-profile-quiz/responses`,
        responses,
        {
          withCredentials: true,
        },
      );
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getSecurityProfileQuiz,
    submitSecurityProfileResponses,
  };
};
